import { React, Header } from 'mondrian-react'
import minhaClaroMovelLogo from '../../assets/minha-claro-movel.svg'

const Topbar = () => {
  return (
    <Header
      brandSrc={minhaClaroMovelLogo}
      brandAlt={'Minha Claro Móvel'}
    />
  )
}
export default Topbar